import React from 'react';
import '../../styles.css';

function LetterCard(props) {
    return (
        <div className='letterCardDiv'>
            <b className='letterCardText'>{props.letter}</b>
            <div className='verticalLine'></div>
            <b className='letterCardText'>{props.percentage}</b>
        </div>
    )
    // Need to figure out the routing and user data flow
}

export default LetterCard;